<template>
    <Transition>
    <div v-if="isOpen" id="connectScreen" class="wallet-connect-button">
        <span class="qr-scanner-close">
            <img @click="openScreen" src="@/assets/img/ico_close_lan.png" alt="close"
                style="width: 20px; height: 20px" />
        </span>

        <div class="details" v-if="peerMeta">


            <div class="logo">
                <img v-if="peerMeta && peerMeta.icons && peerMeta.icons[0]" :src="peerMeta.icons[0]">
                <img v-else src="@/assets/img/walletConnect.png" />
            </div>
            <div class="name">
                <div class="offline" v-if="!connected"></div>
                <div class="online" v-else></div>
                {{ peerMeta.name }}
            </div>
            <div class="url">
                {{ peerMeta.url }}

            </div>
            <div class="description">
                {{ peerMeta.description }}
            </div>

            <div class="address">
               Your Address: {{fixNumber(address)}}
            </div>
        </div>

        <div class="notifications-wrapper">
            <div class="header">
                <div class="title">Requests</div>
                <div class="notification-number">
                    {{ notifications.length }}
                </div>
            </div>
            <div class="notification" v-for="notification in notifications" :key="notification.id"
                @click="makeVisible(notification.id)">
                {{ notification.type }}</div>

        </div>

        <button class="disconnect-button" @click="$emit('disconnect')">Disconnect</button>

    </div>
</Transition>
</template>


<script>
import { fixTheAddress } from "@/filters/index";

export default {

    data() {
        return {}
    },
    methods: {
        openScreen() {

            this.$emit('openScreen', false)


        },
        makeVisible(id) {
            this.$emit('makeVisibleNotif', id)
        },

        fixNumber(val){
           return fixTheAddress(val)
        }
    },
    props: {
        connected: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
        },
        notifications: {
            type: Array,
            default: []
        },
        peerMeta: {
            type: Object
        },

        address:{
            type:String
        }
    },
}
</script>

<style lang="scss" scoped>
.wallet-connect-button {
    display: flex;
    position: fixed;
    flex-direction: column;
    top: 0;
    left: 0;
    z-index: 55;
    width: 100vw;
    height: 100vh;
    background: whitesmoke;
    animation: 0.5s ease jumpIn;
    overflow: auto;

}


.qr-scanner-close {
    margin: 20px;
    display: flex;
    justify-content: flex-end;
}

.notifications-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    overflow: auto;


    .notification {
        display: flex;
        width: 90%;
        margin: 5px;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background: white;
        border-radius: 8px;
    }

    .notification:active {
        transform: scale(0.95);
    }

    .header {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #2bb0e9;
        color: white;
        width: 90%;
        padding: 0 10px;
        margin: 0 5px;
        border-radius: 8px;

        .notification-number {
            display: flex;
            width: 20px;
            height: 20px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin: 10px;
            color: white;
            background: rgba(255, 114, 114, 0.269);
        }
    }
}

.details {

    .description {
        display: flex;
        padding: 10px;
        text-align: center;
        justify-content: center;
        font-size: 0.875rem;
    }

    .name {
        display: flex;
        padding: 10px;
        text-align: center;
        justify-content: center;
        font-weight: 600;
        font-size: 1.2rem;
    }

    .url {
        display: flex;
        padding: 10px;
        text-align: center;
        justify-content: center;
        font-size: 0.875rem;
    }
.address{
    display: flex;
        padding: 10px;
        text-align: center;
        justify-content: center;
        font-size: 0.875rem; 
}
    .logo {
        display: flex;
        justify-content: center;

        img {
            width: 100px;
            height: 100px;
        }
    }

    .offline {
        display: flex;
        min-width: 10px;
        min-height: 10px;
        background: rgb(235, 106, 106);
        border-radius: 50%;
        margin: auto 10px;
    }

    .online {
        display: flex;
        min-width: 10px;
        min-height: 10px;
        background: rgb(84, 227, 84);
        border-radius: 50%;
        margin: auto 10px;

    }

}

.disconnect-button {
    display: flex;
    width: 70%;
    min-width: fit-content;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 8px;
    background: rgb(255, 168, 168);
    color: white;
}

.disconnect-button:active {
    transform: scale(0.95);
}


.v-enter-active,
.v-leave-active {
    transition: all 1s ease;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(150%);
}

@keyframes jumpIn {
    0% {
        transform: translateY(150%);

    }

    100% {
        transform: translateY(0%);

    }
}
</style>